"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loaderStore = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/createSuper"));

var _index = require("./index");

var LoaderStore = /*#__PURE__*/function (_Store) {
  (0, _inherits2.default)(LoaderStore, _Store);

  var _super = (0, _createSuper2.default)(LoaderStore);

  function LoaderStore() {
    (0, _classCallCheck2.default)(this, LoaderStore);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(LoaderStore, [{
    key: "data",
    value: function data() {
      return {
        loading: false
      };
    }
  }, {
    key: "setLoader",
    value: function setLoader(state) {
      this.setState(state);
    }
  }]);
  return LoaderStore;
}(_index.Store);

var loaderStore = new LoaderStore();
exports.loaderStore = loaderStore;